import React from "react";
import { Group, Chip, Badge, Title } from "@mantine/core";

export const BadgesAndChipsStylesheet = () => (
  <>
    <Title order={2} mb={"md"}>
      Badges & Chips
    </Title>

    {/*BADGES*/}
    {/*Status badges - sizes*/}
    <Group mb={"md"} wrap="wrap">
      <Badge size={"xs"}>XS Badge</Badge>
      <Badge size={"sm"}>SM Badge</Badge>
      <Badge>MD Badge</Badge>
      <Badge size={"lg"}>LG Badge</Badge>
      <Badge size={"xl"}>XL Badge</Badge>
    </Group>

    {/*Status badges - colors*/}
    <Group mb={"md"} wrap="wrap">
      <Badge>Primary</Badge>
      <Badge variant={"orchid"}>Orchid</Badge>
      <Badge variant={"carrot"}>Carrot</Badge>
      <Badge variant={"flamingo"}>Flamingo</Badge>
      <Badge variant={"grey"}>Grey</Badge>
    </Group>

    {/*Status badges - icons*/}
    <Group mb={"md"} wrap="wrap">
      <Badge leftSection={<></>}>
        With Left Icon
      </Badge>
      <Badge rightSection={<></>}>
        With Right Icon
      </Badge>
      <Badge
        variant={"carrot-glow-icon"}
        leftSection={<></>}
      >
        With dot
      </Badge>

      {/*Status badges - full-width*/}
      <Badge fullWidth={true}>Full Width Badge</Badge>

      {/*Status badges - AI*/}
      <Badge variant={"ai"} rightSection={<></>}>
        Ai
      </Badge>
    </Group>

    {/*CHIPS*/}
    <Group mb={"md"} wrap="wrap">
      <Chip>Default Chip</Chip>
      <Chip variant={"secondary"}>Default Chip</Chip>
      <Chip variant={"flamingo"}>Secondary Chip</Chip>
      <Chip variant={"carrot"} defaultChecked={true}>
        Secondary Chip
      </Chip>
      <Chip variant={"grey"}> Gray Chip </Chip>
      <Chip variant={"carrot"}>Orange Chip</Chip>
      <Chip variant={"carrot"} defaultChecked={true}>
        Orange Chip
      </Chip>
      <Chip variant={"flamingo"}>Pink Chip</Chip>
      <Chip variant={"flamingo"} defaultChecked={true}>
        Pink Chip
      </Chip>
    </Group>
    <Group mb={"md"} wrap="wrap">
      <Chip.Group multiple>
        <Group wrap="wrap">
          <Chip value={"1"}>You</Chip>
          <Chip variant={"secondary"} value={"2"}>
            Can
          </Chip>
          <Chip variant={"carrot"} value={"3"}>
            Select
          </Chip>
          <Chip variant={"flamingo"} value={"4"}>
            Multiple
          </Chip>
        </Group>
      </Chip.Group>
    </Group>
    <Group mb={"md"} wrap="wrap">
      <Chip.Group>
        <Group wrap="wrap">
          <Chip value={"1"}>Can</Chip>
          <Chip variant={"secondary"} value={"2"}>
            Only
          </Chip>
          <Chip variant={"carrot"} value={"3"}>
            Pick
          </Chip>
          <Chip variant={"flamingo"} value={"4"}>
            One
          </Chip>
        </Group>
      </Chip.Group>
    </Group>
  </>
);
